/** Org-authored RTO lessor / finance sources on Deal Types sale variants. Never hard-code vendors. */

export type SalePathKind = "cash" | "rto" | "finance" | "other";

export function inferSalePathKind(typeKey: string, displayName: string): SalePathKind {
  const s = `${typeKey} ${displayName}`.toLowerCase();
  if (/\brto\b|rent[\s-]?to[\s-]?own/.test(s)) return "rto";
  if (/\bfinance\b|\bloan\b/.test(s)) return "finance";
  if (/\bcash\b/.test(s)) return "cash";
  return "other";
}

export function parseRtoLessor(metadata: Record<string, unknown> | null | undefined): string {
  const v = metadata?.rto_lessor;
  return typeof v === "string" ? v.trim() : "";
}

export function parseFinanceSources(metadata: Record<string, unknown> | null | undefined): string[] {
  const v = metadata?.finance_sources;
  if (Array.isArray(v)) {
    return v.map((x) => (typeof x === "string" ? x.trim() : "")).filter(Boolean);
  }
  if (typeof v === "string") {
    return v
      .split(/\n|,/)
      .map((s) => s.trim())
      .filter(Boolean);
  }
  return [];
}

export function parseAllowedDepositUsd(metadata: Record<string, unknown> | null | undefined): number | null {
  const v = metadata?.allowed_deposit_usd;
  if (typeof v === "number" && Number.isFinite(v) && v >= 0) return Math.round(v * 100) / 100;
  if (typeof v === "string" && v.trim()) {
    const n = Number(v.replace(/[$,]/g, ""));
    if (Number.isFinite(n) && n >= 0) return Math.round(n * 100) / 100;
  }
  return null;
}

export function saleTypeMetadataWithProviders(
  existing: Record<string, unknown> | null | undefined,
  input: { rto_lessor?: string; finance_sources?: string[]; allowed_deposit_usd?: string }
): Record<string, unknown> {
  const next: Record<string, unknown> = { ...(existing ?? {}) };
  if (input.rto_lessor !== undefined) next.rto_lessor = input.rto_lessor.trim();
  if (input.finance_sources !== undefined) {
    next.finance_sources = input.finance_sources.map((s) => s.trim()).filter(Boolean);
  }
  if (input.allowed_deposit_usd !== undefined) {
    const parsed = parseAllowedDepositUsd({ allowed_deposit_usd: input.allowed_deposit_usd });
    if (parsed == null) delete next.allowed_deposit_usd;
    else next.allowed_deposit_usd = parsed;
  }
  return next;
}
